import { ValueTableConfiguration } from "./ValueTableConfiguration";
import { ValueTableRuleEditContext } from "./ValueTableRuleEditContext";
import { TestResultDataType } from "../../../Common/Testing/TestResultDataType";
import { BaseTestResultData } from "../../../Common/Testing/BaseTestResultData";

export class ValueTableTestResult extends BaseTestResultData {
    type: TestResultDataType = TestResultDataType.VALUE_TABLE_RULE;
    editContext?: ValueTableRuleEditContext;

    private _definition?: ValueTableConfiguration;

    get definition(): ValueTableConfiguration | undefined {
        return this._definition;
    }

    set definition(definition: ValueTableConfiguration | undefined) {
        this._definition = definition;

        if (this._definition) {
            this.editContext = new ValueTableRuleEditContext(this._definition);
        }
    }
}

export class ValueTableRowTestResult extends BaseTestResultData {
    type: TestResultDataType = TestResultDataType.VALUE_TABLE_RULE_ROW;
}

export class ValueTableRuleColumnTestResult extends BaseTestResultData {
    type: TestResultDataType = TestResultDataType.VALUE_TABLE_RULE_RULE_COLUMN;
}
